import React, { useLayoutEffect, useRef, useState } from 'react';

import Project from '../home/projects/Project';
import MediaQuery from '../common/MediaQuery';

import { useI18n } from '../i18n/I18nContext';
import ProjectQuery from '../model/Projects';
import Tags from './include/Tags';

function Projects() {
  const { projectPathFor } = useI18n();
  const corners = [
    "top-left bottom-left bottom-right",
    "top-left top-right bottom-left bottom-right",
    "top-left top-right bottom-right"
  ];


  const tags = useState(undefined);
  const filter = tags[0];
  const allProjects = ProjectQuery({filter});
  const gridRef = useRef(null);
  const previousFilter = useRef(filter);

  useLayoutEffect(() => {
    // Preserve keyed cards and focus; only replay the visible results after a change.
    if (previousFilter.current === filter) return;
    previousFilter.current = filter;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;

    const cards = [...gridRef.current.querySelectorAll('[data-reveal]')].filter(card => {
      const bounds = card.getBoundingClientRect();
      return bounds.bottom > 0 && bounds.top < window.innerHeight;
    });
    const animations = cards.flatMap((card, index) => {
      if (!card.animate || card.contains(document.activeElement)) return [];
      // Hand visible cards over from scroll reveal to this one-shot animation.
      card.classList.remove('reveal-pending');
      card.dataset.revealed = 'true';
      return card.animate([
        { opacity: 0, translate: '0 20px' },
        { opacity: 1, translate: '0 0' },
      ], {
        duration: 650,
        delay: Math.min(index * 65, 195),
        easing: 'cubic-bezier(.2, .7, .2, 1)',
        fill: 'backwards',
      });
    });
    const cancel = () => animations.forEach(animation => animation.cancel());
    const grid = gridRef.current;
    // Also reveal immediately if the user tabs into the results during entry.
    grid.addEventListener('focusin', cancel);
    reducedMotion.addEventListener('change', cancel);
    return () => {
      cancel();
      grid.removeEventListener('focusin', cancel);
      reducedMotion.removeEventListener('change', cancel);
    };
  }, [filter]);

  const card = (project, corners) => (
    <Project
      key={project.slug}
      thumbnail={project.thumbnail}
      title={project.title}
      description={project.description}
      href={projectPathFor(project.slug)}
      corners={corners}
      icon={project.icon}
    />
  );
    
  
  const xsmallComponents = allProjects.map((project, index) => card(project, corners[0]));
  const mediumComponents = allProjects.map((project, index) => card(project, corners[(index % 2) * 2]));
  const components = allProjects.map((project, index) => card(project, corners[index % 3]));

  return (
    <section id="projets" className="relative overflow-x-clip py-[5rem] px-10">
      <div className="relative max-w-[1200px] mx-auto z-20">
        <Tags state={tags} />
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-[30px] justify-center w-full pt-[3.75rem]">
          <MediaQuery
            xsmall={xsmallComponents}
            medium={mediumComponents}
            large={components}
          />
        </div>
      </div>
    </section>
  );
}

export default Projects;
